"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonModalPopover = void 0;
const core_1 = require("@material-ui/core");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        zIndex: 1300,
    },
});
function NonModalPopover(props) {
    const { id = 'opsbase-popper', open = false, anchorEl, placement = 'top-start', onClose, onClick, onMouseLeave, transition, classes = {}, style = {}, children, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [], classes);
    const [currentAnchorEl, setCurrentAnchorEl] = (0, react_1.useState)(anchorEl);
    const handleClose = (0, react_1.useCallback)(() => {
        if (!anchorEl)
            return;
        if (currentAnchorEl === anchorEl) {
            setCurrentAnchorEl(null);
            onClose();
        }
        else {
            setCurrentAnchorEl(anchorEl);
        }
    }, [currentAnchorEl, anchorEl, onClose]);
    if (anchorEl && !document.body.contains(anchorEl))
        return null;
    if (!open)
        return null;
    const popper = (react_1.default.createElement(core_1.Popper, { id: id, className: myCss.root, open: true, anchorEl: anchorEl, transition: transition, placement: placement, onClick: onClick, onMouseLeave: onMouseLeave, style: style },
        react_1.default.createElement(core_1.Paper, { elevation: 8, className: classes.paper }, children)));
    return !!onClose ? (react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: handleClose }, popper)) : (popper);
}
exports.NonModalPopover = NonModalPopover;
exports.default = NonModalPopover;
